export default [
    "24 24",
    '<path d="M4 18H14M4 14H20M4 10H14M4 6H20" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

